import { modifier } from 'ember-modifier'

type Callback = (elementId: string) => unknown

interface Signature {
  Args: {
    Named: unknown
    Positional: [Callback]
  }
  Element: HTMLElement
}

/**
 * A modifier to observe for links that have active class applied to them. Will call the callback immediately if one is
 * already present.
 *
 * <div {{onLinkActive this.callback}}>
 *   <a class="active">some actve link</a>
 *   <a>some other link</a>
 * </div>
 */

const onLinkActive = modifier<Signature>(function onLinkActive(element, [callback], _hash) {
  const observer = new MutationObserver((mutationList) => {
    mutationList.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if ((mutation.target as Element).matches('a.active') && !mutation.oldValue?.split(' ').includes('active')) {
          callback(element.id)
        }
      }
    })
  })
  observer.observe(element, { subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['class'] })

  // call it right now if there's an active link inside already
  if (element.querySelector('a.active')) callback(element.id)

  return () => {
    observer.disconnect()
  }
})

export default onLinkActive
